import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Checkbox, Modal, TextField, Typography } from '@material-ui/core';
import ReactTable from 'react-table';
import ActionButton from '../../../components/ActionButton';

import PropTypes from 'prop-types';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    gap: '20px',
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    borderRadius: '6px',
    padding: '20px',
    boxShadow: theme.shadows[6],
    width: '65%',
    maxWidth: '1020px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    overflowY: 'auto',
  },
  modalSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    width: '90%',
  },
  selectAllWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
});

class ModalSelezioneAssociazione extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      columns: [],
      isButtonsAllChecked: true,
    };
  }

  getRepartoIdByName = (name) => {
    const reparto = this.props.reparti.find((item) => item.nome === name);
    return reparto ? reparto.id : null;
  };

  componentDidMount = () => {
    let columns = [];
    let records = [];

    if (this.props.mode === 'Attrezzature') {
      const attrezzatureIds = (
        this.props.controlloSelezionato.attrezzature || []
      ).map(String);
      this.props.attrezzature.forEach((attrezzatura) => {
        if (
          attrezzatura.tipologiaStrumentazioneId ===
            this.props.controlloSelezionato.tipologiaStrumentazioneId ||
          this.props.controlloSelezionato.selectedTipologiaElemento ===
            attrezzatura.tipologiaStrumentazioneId
        ) {
          const isChecked = attrezzatureIds.includes(attrezzatura.id);
          const newRecord = {
            checked: isChecked,
            nomeReparto: attrezzatura.nomeReparto,
            nomeLocale: attrezzatura.nomeLocale,
            id: attrezzatura.id,
            idTipologia: attrezzatura.tipologiaStrumentazioneId,
            nomeElemento: attrezzatura.nome,
            repartoId: this.getRepartoIdByName(attrezzatura.nomeReparto),
          };
          records.push(newRecord);
        }
      });
      columns = this.getColumnTabellaAttrezzature();
    } else {
      if (this.props.reparti.length === 1) {
        records.push({
          nomeReparto: this.props.reparti[0].nome,
          checked: true,
          idReparto: this.props.reparti[0].id,
          repartoDefault: true,
        });
      } else {
        this.props.reparti.forEach((reparto) => {
          if (!reparto.repartoDefault) {
            const isChecked = this.props.controlloSelezionato.reparti.includes(
              reparto.id,
            );
            records.push({
              nomeReparto: reparto.nome,
              checked: isChecked,
              idReparto: reparto.id,
              repartoDefault: false,
            });
          }
        });
      }
      columns = this.getColumnTabellaReparti();
    }
    this.setState(
      {
        records: records,
        isButtonsAllChecked: true,
        columns,
      },
      this.checkIfAllAreSelected,
    );
  };

  getColumnTabellaReparti = () => {
    return [
      {
        Header: 'Reparto',
        id: 'Reparto',
        minWidth: 240,
        accessor: (d) => d,
        Cell: (props) => (
          <TextField
            contentEditable={false}
            style={{ margin: 10 }}
            InputProps={{ disableUnderline: true }}
            inputProps={{ min: 0, style: { textAlign: 'center' } }}
            value={props.row.Reparto.nomeReparto}
          />
        ),
      },
      {
        Header: 'Associa',
        id: 'Associa',
        minWidth: 150,
        accessor: (d) => d,
        Cell: (props) => (
          <Checkbox
            onClick={() => {
              let array = [...this.state.records];
              array[props.index].checked = !array[props.index].checked;
              this.setState(
                {
                  records: array,
                  isButtonsAllChecked: true,
                },
                () => {
                  this.checkIfAllAreSelected();
                },
              );
            }}
            checked={props.row.Reparto.checked}
            disabled={props.row.Associa.repartoDefault}
            style={{ margin: 10 }}
          />
        ),
      },
    ];
  };

  getColumnTabellaAttrezzature = () => {
    return [
      {
        Header: 'Elemento Osservato',
        id: 'ElementoOsservato',
        minWidth: 240,
        accessor: (d) => d.nomeElemento,
        Cell: (props) => {
          // console.log(props.row);
          return (
            <TextField
              contentEditable={false}
              style={{ margin: 10 }}
              InputProps={{ disableUnderline: true }}
              inputProps={{ min: 0, style: { textAlign: 'center' } }}
              value={props.row.ElementoOsservato}
            />
          );
        },
      },
      {
        Header: 'Reparto',
        id: 'Reparto',
        minWidth: 240,
        accessor: (d) => d.nomeReparto,
        Cell: (props) => (
          <TextField
            contentEditable={false}
            style={{ margin: 10 }}
            InputProps={{ disableUnderline: true }}
            inputProps={{ min: 0, style: { textAlign: 'center' } }}
            value={props.row.Reparto}
          />
        ),
      },
      {
        Header: 'Locale',
        id: 'Locale',
        minWidth: 240,
        accessor: (d) => d.nomeLocale,
        Cell: (props) => (
          <TextField
            contentEditable={false}
            style={{ margin: 10 }}
            InputProps={{ disableUnderline: true }}
            inputProps={{ min: 0, style: { textAlign: 'center' } }}
            value={props.row.Locale}
          />
        ),
      },
      {
        Header: 'Associa',
        id: 'Associa',
        width: 120,
        accessor: (d) => d,
        Cell: (props) => (
          <Checkbox
            onClick={() => {
              let array = [...this.state.records];
              array[props.index].checked = !array[props.index].checked;
              this.setState(
                {
                  records: array,
                  isButtonsAllChecked: true,
                },
                () => {
                  this.checkIfAllAreSelected();
                },
              );
            }}
            checked={props.row.Associa.checked}
            style={{ margin: 10 }}
          />
        ),
      },
    ];
  };

  selectAll = () => {
    const { records, isButtonsAllChecked } = this.state;

    if (records.length > 0 && !records[0].repartoDefault) {
      const updatedRecords = records.map((item) => ({
        ...item,
        checked: !isButtonsAllChecked,
      }));

      this.setState({
        records: updatedRecords,
        isButtonsAllChecked: !isButtonsAllChecked,
      });
    }
  };

  checkIfAllAreSelected = () => {
    const allSelected = this.state.records.every((item) => item.checked);
    this.setState({
      isButtonsAllChecked: allSelected,
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <div className={classes.modalSectionContainer}>
            {this.props.mode === 'Attrezzature' ? (
              <Typography style={{ align: 'center', fontSize: 30 }}>
                Attrezzature
              </Typography>
            ) : (
              <Typography style={{ align: 'center', fontSize: 30 }}>
                Reparti
              </Typography>
            )}
            <div className={classes.selectAllWrapper}>
              <ActionButton
                size="small"
                label={
                  !this.state.isButtonsAllChecked
                    ? 'Seleziona tutto'
                    : 'Deseleziona tutto'
                }
                onClick={this.selectAll}
              />
            </div>
            <ReactTable
              filterable={false}
              resizable={true}
              enableEditing={true}
              showPageSizeOptions={false}
              showPageJump={true}
              defaultPageSize={5}
              data={this.state.records}
              columns={this.state.columns}
              previousText="Precedente"
              nextText="Successivo"
              noDataText="Nessun record"
              pageText="Pagina"
              ofText="di"
              rowsText="righe"
              pageJumpText="Vai a pagina"
              rowsSelectorText="righe per pagina"
            />
          </div>
          {this.props.mode === 'Attrezzature' ? (
            <div>
              <ActionButton
                label="Chiudi"
                secondaryButton
                onClick={this.props.onClose}
              />
              <ActionButton
                label="Salva"
                onClick={() =>
                  this.props.saveValues(this.state.records, 'Attrezzatura')
                }
              />
            </div>
          ) : (
            <div>
              <ActionButton
                label="Chiudi"
                secondaryButton
                onClick={this.props.onClose}
              />
              <ActionButton
                label="Salva"
                onClick={() =>
                  this.props.saveValues(this.state.records, 'Reparto')
                }
              />
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

ModalSelezioneAssociazione.propTypes = {
  attrezzature: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  controlloSelezionato: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  reparti: PropTypes.array.isRequired,
  saveValues: PropTypes.func.isRequired,
};

export default withStyles(styles)(ModalSelezioneAssociazione);
